import { db } from "../";
import { Course } from "../components/form/ApplicationForm";
import { courses } from "../components/form/ApplicationForm";

// const COUPON_ENTITY = "coupons";
const STUDENT_ENTITY = "students";

/** 22.06.13에 start2, ts11, ts21 콜렉션 생성 */
export type CouponTable =
  | "coupon-vue-start3"
  | "coupon-vue3-start"
  | "coupon-vue-intermediate"
  | "coupon-vue3-intermediate"
  | "coupon-webpack"
  | "coupon-vue-advanced"
  | "coupon-vue-endgame"
  | "coupon-ts12"
  | "coupon-ts22"
  | "coupon-vue-ts"
  | "coupon-react-vue-ts"
  | "coupon-pwa"
  | "coupon-next-js"
  | "coupon-react-start"
  | "coupon-testing-start";

interface StudentInfo {
  email: string;
  name: string;
  birth: string;
  school: string;
  studentStatus: string;
  file: { fileName: string; fileType: string };
  verified: boolean;
  /** Unix 타임 스탬프 값(데이터 오더링 용) */
  currentTime: number;
  /** 로깅 & 디버깅 용도의 데이터 삽입 시간 */
  insertedAt: string;
}

function insertStudentInfo(studentInfo: StudentInfo) {
  return db.collection(STUDENT_ENTITY).add(studentInfo);
}

function fetchCouponByTableId(tableId: CouponTable = "coupon-vue-start3") {
  return db.collection(tableId).where("사용여부", "!=", 1).limit(1).get();
}

/**
 * @description 할인 쿠폰 정보를 모두 들고오는 API
 */
function fetchCoupons() {
  return Promise.all(
    courses.map((course) => {
      return db.collection(course.id).get();
    }),
  );
}

export interface Coupon {
  id: string;
  사용여부: number;
  생성일: string;
  종류: string;
  코드: string;
}

export interface UsedCoupon extends Coupon {
  email: string;
  currentTime: number;
  insertedAt: string;
  student: string;
  course: string;
}

// NOTE: https://saveyourtime.medium.com/firebase-cloud-firestore-add-set-update-delete-get-data-6da566513b1b
function markCouponUsed({
  docId,
  student,
  email,
  course,
}: {
  docId: string;
  student: string;
  email: string;
  course: Course;
}) {
  return db.collection(course.id).doc(docId).update({
    사용여부: 1,
    student,
    email,
    course: course.title,
    currentTime: new Date().getTime(),
    insertedAt: new Date().toLocaleString(),
  });
}

export {
  insertStudentInfo,
  fetchCouponByTableId,
  fetchCoupons,
  markCouponUsed,
};
